import React from "react";
import lineAnimation from "../../lottie/left_lines.json";
import Lottie from "lottie-react";

const values = [
  {
    title: "Empathy",
    icon: "fa-hand-holding-heart",
    description:
      "We share our client's emotions, and we learn your language so you don’t have to learn ours.",
  },
  {
    title: "Quality",
    icon: "fa-award",
    description: "We sweat the details for you, and continuous improvement is in our DNA.",
  },
  {
    title: "Integrity",
    icon: "fa-shield-halved",
    description: "Trust will never be commonplace. When times get tough, we see things through.",
  },
  {
    title: "Impact",
    icon: "fa-bullseye",
    description:
      "We deliver immediate results, while actively look for opportunities to build long-term value.",
  },
  {
    title: "Simplicity",
    icon: "fa-feather",
    description: "Technology can be overwhelming, we simplify complex decision-making.",
  },
  {
    title: "Responsiveness",
    icon: "fa-bolt",
    description:
      "Speed is crucial to innovation, so we respond rapidly to issues and changing priorities.",
  },
];

export default function CelebrationValues() {
  return (
    <section className="relative w-full py-16 md:py-24">
      <div className="relative z-10 mx-auto theme-container">
        <h2 className="mx-auto max-w-2xl text-center text-34 font-semibold text-main-black md:text-48" data-aos="fade-up">
          What Drives Us
        </h2>

        <div className="mt-12 w-full rounded-[10px] border border-[#e3e7fa] bg-main-gray px-5 py-[60px] md:px-10 xl:px-[80px] xl:py-[130px]">
          <div className="grid w-full grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 xl:gap-[70px]">
            {values.map((value, index) => (
              <div
                key={value.title}
                data-aos="zoom-in-left"
                data-aos-delay={index * 100}
                className="group flex flex-col items-center justify-between space-y-[30px] rounded-[10px] border border-transparent bg-white px-8 py-10 common-transition hover:-translate-y-[5px] hover:border-purple hover:shadow-common"
              >
                <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full bg-yellow/60 text-black common-transition group-hover:scale-[1.06] group-hover:bg-yellow group-hover:text-black">
                  <i className={`fa-solid ${value.icon} text-2xl`} aria-hidden="true"></i>
                </div>
                <div>
                  <p className="mb-4 text-center text-20 font-semibold text-main-black">{value.title}</p>
                  <p className="text-center text-paragraph">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pointer-events-none absolute inset-x-0 top-1/3 z-0 hidden justify-between overflow-hidden sm:flex">
        <Lottie animationData={lineAnimation} loop={true} />
        <Lottie animationData={lineAnimation} className="transform rotate-180" loop={true} />
      </div>
    </section>
  );
}
